import React from "react";

import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";

// Types
// import RootStore from '~/store/modules/RootStore';
// Hooks
import { useAppointmentSteps } from "~/hooks/useAppointmentSteps";
// Styles
import s from "./ProgressSteps.module.scss";
import { observer } from "mobx-react-lite";
import { styled } from "@mui/material";

interface Props {}

const LinearProgressStyled = styled(LinearProgress)(() => ({
  height: 7,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#CBD5E0",
  },
}));

const ProgressSteps: React.FC<Props> = observer(({}) => {
  const { currentStep, currentProgressPercent, currentProgressStep, steps } =
    useAppointmentSteps();

  return (
    <div className={s.progressBar}>
      <div className={s.progressBarTitleContainer}>
        <div>
          <p className={s.progressBarTitle}>
            {currentStep?.title?.toUpperCase()}
          </p>
        </div>
        <div className={s.progressBarSteps}>
          <p className={s.progressBarStep}>
            {`${currentProgressStep} / ${steps.length}`}
          </p>
        </div>
      </div>
      <LinearProgressStyled
        value={currentProgressPercent}
        variant="determinate"
        color="primary"
        sx={{
          "&MuiLinearProgress-bar1Determinate": {
            height: "2px",
          },
        }}
      />
    </div>
  );
});

export default ProgressSteps;
